<template>
    <div class="white-bg list-item">

        <img src="../../../../assets/close.png" alt="" @click="deleteItem" class="list-item-close">

        <strong @click="gotoEdit">{{dataInfo.name}}</strong>

        <div>
            <div>
                <div class="name">电话</div>
                <div class="value">{{dataInfo.phone}}</div>
            </div>
            <div>
                <div class="name">分享时间</div>
                <div class="value">{{getTimeStart}}</div>
            </div>
            <div>
                <div class="name">授权次数</div>
                <div class="value">{{getNum}}</div>
            </div>
            <div>
                <div class="name">有效日期</div>
                <div class="value">{{getTimeEnd}}</div>
            </div>
            <div class="key-item-progress">
                <div :style="{width: getProgress, backgroundColor: getProgressColor}"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    import axios from "axios";
    import {Message} from 'element-ui';
    import {MessageBox} from 'element-ui';

    export default {
        name: "ListItem",

        props: {
            rentEnd: Number,
            bindName: String,
            leaseID: String,
            dataInfo: {},
            orgID:String,
        },

        methods: {
            getProgressNum() {
                if (this.dataInfo.authStart && this.dataInfo.authEnd) {
                    return ((new Date().getTime()/1000 - this.dataInfo.authStart)
                        / (this.dataInfo.authEnd - this.dataInfo.authStart)) * 100;
                }
                return 0;
            },

            //编辑分享
            gotoEdit() {
                let vue = this;
                // 微信小程序
                wx.miniProgram.getEnv(function() {
                    wx.miniProgram.navigateTo({
                        url: "/pages/mkey/addvisitor?"
                            + "leaseID=" + vue.leaseID
                            + "&bindName=" + encodeURI(vue.bindName)
                            + "&authEnd=" + vue.dataInfo.authEnd
                            + "&rentEnd=" + vue.rentEnd
                            + "&name=" + vue.dataInfo.name
                            + "&userID=" + vue.dataInfo.userID
                            + "&phone=" + vue.dataInfo.phone
                            + "&authTimes=" + vue.dataInfo.authTimes
                    });
                });
            },

            deleteItem() {
                console.log( this.dataInfo)
                console.log( this.orgID)
                let vue = this;
                MessageBox.confirm('此操作将删除' + this.dataInfo.name + ', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = axios.defaults.baseURL.replace('v1/org/','')
                    axios({
                        method: 'post',
                        url: url+"v2/visitors/delete",
                        headers: {
                             'Authorization': this.$route.query.token,
                            'PYDDot-Client-Type':this.$route.query.client,
                            'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
                        },
                        data: {
                            "id": this.dataInfo.id,
                            "orgID": this.orgID,
                        },
                    }).then(value => {
                        if (value.data.code === 0) {
                            Message.success("删除成功");
                            vue.$emit("delete-item");
                        }
                        else {
                            Message.error(value.data.message);
                        }
                    }).catch((reason) => {
                        Message.error(reason.toString());
                    });
                }).catch(() => {});
            }
        },

        computed: {
            getProgress() {
                return this.getProgressNum() + "%";
            },

            getProgressColor() {
                if (this.getProgressNum() <= 50) {
                    return "#99D2BB";
                }
                else if (this.getProgressNum() <= 80) {
                    return "#F5A173";
                }
                else {
                    return "#EB5E5E";
                }
            },

            getTimeStart() {
                let authStart = new Date(this.dataInfo.authStart * 1000);
                return authStart.getFullYear() + "-"
                    + (authStart.getMonth() + 1) + "-"
                    + authStart.getDate();
            },

            getTimeEnd() {
                let endTime = new Date(this.dataInfo.authEnd * 1000);
                return endTime.getFullYear() + "-"
                    + (endTime.getMonth() + 1) + "-"
                    + endTime.getDate();
            },

            getNum() {
                if(this.dataInfo.authTimes === null || this.dataInfo.authTimes === "") {
                    return "";
                }
                if (this.dataInfo.authTimes > 0) {
                    return this.dataInfo.authTimes;
                }
                else {
                    return "无限次";
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    .list-item {
        position: relative;
        border-radius: 10px;
        width: 90%;
        display: flex;
        align-items: center;

        .list-item-close {
            width: 20px;
            top: 2px;
            left: 2px;
            position: absolute;
        }

        strong {
            min-width: 80px;
            color: $fontColor-3;
            font-size: 20px;
        }
        >div {
            box-sizing: border-box;
            padding-left: 10px;
            width: 100%;
            >div {
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                img {
                    height: 15px;
                }
                .name {
                    color: $fontColor-9;
                }
                .value {
                    color: $fontColor-6;
                }
            }
        }
        .key-item-progress {
            border-radius: 50px;
            width: 100%;
            height: 5px;
            background: $bgColor;
            div {
                border-radius: 50px;
                width: 50%;
                height: 5px;
                background: red;
            }
        }
    }

</style>
